import { useMemo } from 'react';

import { useCaptionDisplayConfig } from './useCaptionDisplayConfig';

import { useAppSelector } from 'features/app/hooks';
import { makeSelectCaptionTurns } from 'features/call/call-captions/store';

export const useCaptionTurns = () => {
  const captionDisplayConfig = useCaptionDisplayConfig();
  const selectCaptionTurns = useMemo(
    () => makeSelectCaptionTurns(captionDisplayConfig),
    [captionDisplayConfig]
  );

  return useAppSelector(selectCaptionTurns);
};
